import { useAppSelector } from "../../common/hooks"
import {
  useFetchBrandQuery,
  useFetchLoanOfficerQuery
} from "../../redux/queries"
import { selectUserDetails } from "../../redux/slices/auth"
import {
  ApiMarketingFeatureCard,
  apiMarketingFeatures
} from "./components/api-marketing-feature-card"
import { ApiMarketingHero } from "./components/api-marketing-hero"
import { ApiMarketingCta } from "./components/api-marketing-cta"
import { buildApiAccessMailtoLink, getBrandName } from "./api-marketing-utils"

export const ApiMarketingContent = () => {
  const user = useAppSelector(selectUserDetails)

  const { data: loProfile } = useFetchLoanOfficerQuery(user?.id || "", {
    skip: !user?.id
  })

  const { data: brandDetails } = useFetchBrandQuery(loProfile?.bank_nid || "", {
    skip: !loProfile?.bank_nid
  })

  const fullName =
    loProfile?.first_name && loProfile?.last_name
      ? `${loProfile.first_name} ${loProfile.last_name}`
      : loProfile?.name || user?.login || ""

  const brandName = getBrandName(brandDetails, loProfile, user)

  const mailtoLink = buildApiAccessMailtoLink(
    fullName,
    user?.email || "",
    brandName
  )

  return (
    <div className="max-w-4xl mx-auto py-12">
      <ApiMarketingHero />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        {apiMarketingFeatures.map(feature => (
          <ApiMarketingFeatureCard key={feature.title} {...feature} />
        ))}
      </div>

      <ApiMarketingCta mailtoHref={mailtoLink} />
    </div>
  )
}
